import type { FunctionComponent } from 'react';
import type { ConnectedComponent } from 'react-redux';

import * as id from 'src/app/constants/pageUid';
import type { RouteName } from 'src/app/routes';
import ClassifyPage from 'src/app/views/pages/Classify';
import { CreatePage } from 'src/app/views/pages/Create';
import { EditPage } from 'src/app/views/pages/Edit';
import { EditPayAndPostPage } from 'src/app/views/pages/EditPayAndPost';
import {
  ConciergePage,
  GuaranteedHirePage,
  PremiumPlusPage,
} from 'src/app/views/pages/JobAdBooking';
import ManagePage from 'src/app/views/pages/Manage';
import PayAndPostPage from 'src/app/views/pages/PayAndPost';
import { RefreshPage } from 'src/app/views/pages/Refresh';
import SelectAdTypePage from 'src/app/views/pages/SelectAdType';
import SuccessPage from 'src/app/views/pages/Success';
import WritePage from 'src/app/views/pages/Write';

import { MultiLocationPage } from '../views/pages/MultiLocation';
import { RefreshError } from '../views/pages/Refresh/components/RefreshError';

// Specify the Page component for each route
export const routeNameToPage: Record<
  RouteName,
  FunctionComponent | ConnectedComponent<any, any>
> = {
  // Create flow routes
  [id.PAGE_ID_CREATE]: CreatePage,
  [id.PAGE_ID_CLASSIFY]: ClassifyPage,
  [id.PAGE_ID_CONCIERGE]: ConciergePage,
  [id.PAGE_ID_GUARANTEED_HIRE]: GuaranteedHirePage,
  [id.PAGE_ID_PREMIUM_PLUS]: PremiumPlusPage,
  [id.PAGE_ID_MANAGE]: ManagePage,
  [id.PAGE_ID_PAY_AND_POST]: PayAndPostPage,
  [id.PAGE_ID_SELECT_AD_TYPE]: SelectAdTypePage,
  [id.PAGE_ID_SUCCESS]: SuccessPage,
  [id.PAGE_ID_WRITE]: WritePage,
  // Edit flow route components
  [id.PAGE_ID_EDIT]: EditPage,
  [id.PAGE_ID_EDIT_PAY_AND_POST]: EditPayAndPostPage,
  [id.PAGE_ID_EDIT_SUCCESS]: SuccessPage,
  // Refresh flow route components
  [id.PAGE_ID_REFRESH]: RefreshPage,
  [id.PAGE_ID_REFRESH_SUCCESS]: SuccessPage,
  [id.PAGE_ID_REFRESH_ERROR]: RefreshError,
  // Multi location route component
  [id.PAGE_ID_MULTI_LOCATION]: MultiLocationPage,
};
